import React, { useState, useContext, useEffect } from "react";
import { Box, Container, useMediaQuery } from "@mui/material";
import RouterSwap from "./RouterSwap";
import { AppContext } from "./../../utils";
import NetworkModal from "./networkModal";

import c1 from "../Stake/assets/c1.svg";
import c2 from "../Stake/assets/c2.svg";
import c3 from "../Stake/assets/c3.svg";
import c4 from "../Stake/assets/c4.svg";

import f1 from "../Stake/assets/f1.svg";
import f2 from "../Stake/assets/f2.svg";
import f3 from "../Stake/assets/f3.svg";
import f4 from "../Stake/assets/f4.svg";
import f5 from "../Stake/assets/f5.svg";
import f6 from "../Stake/assets/f6.svg";

import mc1 from "../Stake/mAssets/c1.svg";
import mf1 from "../Stake/mAssets/f1.svg";
import mf2 from "../Stake/mAssets/f2.svg";

function Bridge() {
  const mobile = useMediaQuery("(max-width:1050px)");

  const [open, setOpen] = useState(false);

  const { account, chainId, connect } = useContext(AppContext);
  const [selected, setSelected] = useState("");

  const [currentChainId, setCurrentChainId] = useState();

  useEffect(() => {
    if (!account) {
      connect();
    }
    if (chainId) {
      console.log(chainId, "chainId");
      setCurrentChainId(chainId);
    }
  }, [chainId]);
  console.log(currentChainId, "chainId");
  return (
    <div
      style={{
        background:
          "radial-gradient(68.29% 68.29% at 50% 50%, #73246C 0%, #1A103B 100%)",
        backgroundSize: "cover",
        width: "100%",
        paddingTop: "75px",
        paddingBottom: "75px",
        zIndex: "-5",

        overflowX: "hidden",
      }}
    >
      <NetworkModal
        setSelected={setSelected}
        open={open}
        setOpen={setOpen}
        setCurrentChainId={setCurrentChainId}
      />
      <Container sx={{ maxWidth: "xl" }}>
        {mobile ? (
          <></>
        ) : (
          <>
            {/* f2  */}
            <Box sx={{ position: "relative" }}>
              <img
                src={f2}
                className="updown"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "320px",
                  marginLeft: "-40px",
                }}
                alt=""
              />

              {/* c1  */}

              <img
                className="rotateY"
                src={c1}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "100px",
                  marginLeft: "-100px",
                }}
                alt=""
              />
              {/* f1  */}

              <img
                className="diagonal"
                src={f1}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "130px",
                  marginLeft: "-20px",
                }}
                alt=""
              />
              {/* f3  */}

              <img
                src={f3}
                className="updown"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-70px",
                  marginLeft: "800px",
                }}
                alt=""
              />
              {/* f5  */}

              <img
                className="updown"
                src={f5}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "260px",
                  marginLeft: "1090px",
                }}
                alt=""
              />
              {/* c3  */}

              <img
                className="rotate"
                src={c3}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "100px",
                  marginLeft: "1000px",
                }}
                alt=""
              />

              {/* f4  */}

              <img
                className="rotate"
                src={f4}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "60px",
                  marginLeft: "1100px",
                }}
                alt=""
              />
            </Box>
          </>
        )}
        <RouterSwap
          setOpen={setOpen}
          selected={selected}
          currentChainId={currentChainId}
        />

        {mobile ? (
          <>
            <Box pb="80px">
              {/* mf1   */}
              <img
                className="updown"
                src={mf1}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-10px",
                  marginLeft: "40px",
                }}
                alt=""
              />

              {/* mc1   */}
              <img
                src={mc1}
                className="rotate"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-10px",
                  marginLeft: "60px",
                }}
                alt=""
              />
            </Box>
          </>
        ) : (
          <>
            {/* c2  */}

            <Box sx={{ position: "relative" }}>
              <img
                className="rotateX"
                src={c2}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-250px",
                  marginLeft: "-20px",
                }}
                alt=""
              />
            </Box>
          </>
        )}
      </Container>
    </div>
  );
}

export default Bridge;
